import { motion } from "framer-motion";
import {
  Wifi, CookingPot, Bath, Tv, Heater, PawPrint, Baby, ShieldCheck,
  DoorOpen, CigaretteOff, Flame, Waves,
} from "lucide-react";
import ChapterHeading from "@/components/landing/ChapterHeading";

const AMENITIES = [
  { icon: Waves, title: "Piscina SPA gonfiabile riscaldata", note: "Scoperta · tutto l'anno", big: true },
  { icon: Wifi, title: "WiFi gratuito", note: "In tutta la struttura" },
  { icon: CookingPot, title: "Cucina attrezzata", note: "Forno · piano cottura · utensili" },
  { icon: Bath, title: "Bagno privato", note: "Doccia · bidet · asciugamani" },
  { icon: Tv, title: "TV", note: "Relax serale in camera" },
  { icon: Heater, title: "Riscaldamento", note: "Comfort in ogni stagione" },
  { icon: PawPrint, title: "Animali ammessi", note: "Su richiesta" },
  { icon: DoorOpen, title: "Piano terra", note: "Ingresso privato indipendente" },
  { icon: Baby, title: "Per i più piccoli", note: "Cancelletti di sicurezza" },
  { icon: ShieldCheck, title: "Sicurezza", note: "Estintori · CCTV esterno · rilevatore CO" },
  { icon: Flame, title: "Allarme antifumo", note: "Protezione completa" },
  { icon: CigaretteOff, title: "Non fumatori", note: "Struttura interamente smoke-free" },
];

export default function Servizi() {
  return (
    <section id="servizi" data-testid="servizi-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-36">
      <ChapterHeading
        eyebrow="I Comfort"
        title="Servizi & Comfort"
        subtitle="Tutto ciò che serve per un soggiorno senza pensieri — e qualcosa in più."
      />

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {AMENITIES.map((a, i) => (
          <motion.div
            key={a.title}
            data-testid={`amenity-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 4) * 0.07 }}
            whileHover={{ y: -4 }}
            className={`rounded-sm border border-stone-300/50 bg-white p-6 transition-shadow duration-300 hover:shadow-lg hover:shadow-stone-900/10 ${
              a.big ? "col-span-2 row-span-1 bg-olive text-linen lg:col-span-2" : ""
            }`}
          >
            <span className={`mb-4 flex h-11 w-11 items-center justify-center rounded-full ${a.big ? "bg-oro/20 text-oro" : "bg-terracotta/10 text-terracotta"}`}>
              <a.icon size={20} />
            </span>
            <h3 className={`font-serif text-lg ${a.big ? "text-2xl text-linen" : "text-stone-800"}`}>{a.title}</h3>
            <p className={`mt-1 text-xs uppercase tracking-[0.12em] ${a.big ? "text-linen/70" : "text-stone-500"}`}>{a.note}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
